import useYetizProfileEncoder from "../../yetizProfileEncoder/useYetizProfileEncoder";
import yetiz from "yetiz";


async function downloadFile(buffer, filename = "immagine.pdf", type = "PDF") {
    let blob;
    if (type === "PDF") {
        blob = new Blob([buffer], {type: "application/pdf"});
    } else if (type === "PNG") {
        blob = new Blob([buffer], {type: "image/png"});
    }

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}


const useYetizSnowProfileDownload = (yetizProperties = {}) => {
    const yetizProfileEncoder = useYetizProfileEncoder();

    const handleDownload = async (model23) => {
        // Create hidden SVG element if not already present
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "1000px");
        svg.setAttribute("height", "1414px");
        svg.style.position = "absolute";
        svg.style.left = "-99999px";
        svg.style.top = "-99999px";
        document.body.appendChild(svg);

        const fileName = model23 ? `${model23.station.code}_${model23.datetime}.pdf` : 'profile.pdf';

        // Encode profile to JSON
        const properties = {
            right_icon: '/img/models4_small.png',
            right_icon_caption: "YetiWeb",
            left_icon: model23.station?.workgroup?.logo?.path,
            left_icon_caption: model23.station?.workgroup?.name,
            ...yetizProperties,
        }
        const jsonProfile = yetizProfileEncoder.encodeJSON(model23);

        return new Promise((resolve, reject) => {
            yetiz.Parser.parse(jsonProfile, 'json', (err, station) => {
                if (err) {
                    reject(err);
                    return;
                }

                let graph;

                try {
                    graph = new yetiz.SnowProfile(station, svg, properties);

                    yetiz.Graph.convert("PDF", graph, (data) => {
                        try {
                            downloadFile(data, fileName, "PDF");
                            resolve(); // ✅ download avviato
                        } catch (e) {
                            reject(e);
                        } finally {
                            svg.remove();
                        }
                    });

                } catch (e) {
                    reject(e);
                    svg.remove();
                }
            });
        });
    }

    return {handleDownload}
}

export default useYetizSnowProfileDownload;